module.exports = __webpack_public_path__ + "img/img_raiders@2x.daa21851.png";